// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ChangeEvent, useEffect, useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import CheckPointIcon from '../../../assets/images/CheckPoint.svg';
import LoadingIcon from '../../../components/LoadingIcon'
import { FormattedMessage } from 'react-intl';
import GoNextTask from './GoNextTask';
import { useIntl } from 'react-intl';
import { checkAnswer } from '../../../apis/challenge';
import { useParamsId } from '../../../lib/utility';
import { useAlert } from 'react-alert';

const S = {
  Frame: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 84px;
    margin-bottom: 40px;
  `,
  Container: styled.div<{ isDefaultStyle?: boolean }>`
    display: flex;
    width: 663px;
    height: 105px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    background: #FFFFFF;
    ${props => {
      if (props.isDefaultStyle) {
        return 'border: 1px solid #DEDEDE;'
      } else {
        return 'border: 1px solid #FE4747;'
      }
    }}
  `,
  Img: styled.img.attrs({ src: CheckPointIcon })`
    display: flex;
    margin-left: 35px;
  `,
  Message: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #434343;
    margin-left: 11.88px;
    align-items: center;
    width: 473.12px;
  `,
  TokenInputField: styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 31px;
    height:105px
  `,
  Input: styled.input<{ isDefaultStyle?: boolean }>`
    display: flex;
    width: 246px;
    height: 43px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 30.12px;
    padding-left: 15px;
  ${props => {
      if (!props.isDefaultStyle) {
        return 'border: 1px solid #FE4747;'
      } else {
        return 'border: 1px solid #DEDEDE;'
      }
    }}
  `,
  TokenWrongMessage: styled.div<{ answerType?: string }>`
    display: flex;
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #F85656;
    padding-top: 3px;
    ${props => {
      if (props.answerType == 'Token') {
        return 'margin-left: 45.12px;'
      } else {
        return 'margin-left: 130.12px;'
      }
    }}
  `,
  ButtonFrame: styled.div`
    display: flex;
    align-items: center;
  `,
  Button: styled.div<{ answerType?: string, isDefaultStyle?: boolean, isChecking?: boolean }>`
    display: flex;
    cursor: pointer;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    height: 43px;
    width: 71px;
  ${props => {
      if (props.answerType == 'Token') {
        if (props.isChecking) {
          return 'background: rgba(239, 130, 0, 0.2);'
        }
        return 'background: #EF8200;'
      } else {
        if (props.isChecking) {
          return 'background: rgba(239, 130, 0, 0.2);'
        } else if (!props.isDefaultStyle) {
          return 'background: #EF8200;'
        }
        return 'background: #EF8200;'
      }
    }}
  `,
  ButtonText: styled.div<{ answerType?: string }>`
    display: flex;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
  `
}

const MessageSwitcher = (props: any): JSX.Element => {
  if (props.answerType == 'Token') {
    return (<FormattedMessage id="E044" values={{ br: <br /> }}></FormattedMessage>)
  } else {
    return (<FormattedMessage id="E045" values={{ br: <br /> }}></FormattedMessage>)
  }
}

const ButtonSwitcher = (props: any): JSX.Element => {
  if (props.isChecking) {
    return (<LoadingIcon size={5} />)
  } else {
    return (<FormattedMessage id="E049" />)
  }
}

function useResetContainerStyle<T extends HTMLElement>(isDefaultStyle: boolean, resetContainerStyle: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (isDefaultStyle) return;
    function handleContainerStyle(e: MouseEvent) {
      console.log(ref.current, e.target)
      if (!ref.current?.contains(e.target as Node)) {
        resetContainerStyle();
      }
    }
    window.addEventListener('click', handleContainerStyle);
    return () => {
      window.removeEventListener('click', handleContainerStyle);
    }
  }, [isDefaultStyle, resetContainerStyle, ref.current])
  return ref;
}

const CheckAnswer = (props: any): JSX.Element => {
  const intl = useIntl();
  const id = useParamsId();
  const alert = useAlert();
  // The Status of User in this challenge
  const isFinalTask = props.isFinalTask;
  const [answerType, setAnswerType] = useState('');
  const [inputToken, setInputToken] = useState('');
  const [isChecking, setIsChecking] = useState(false);
  const setNavigationFocus = props.setNavigationFocus;
  const setNavigationClickToRender = props.setNavigationClickToRender;
  const navigationList = localStorage.getItem('navigationList');
  const currentTask = props.navigationFocus;
  const handleEndChallenge = props.handleEndChallenge;
  const [isDefaultStyle, setDefaultStyle] = useState(true);
  const [isCorrect, setCorrect] = useState(() => {
    const status = localStorage.getItem(currentTask + ' Complete');
    if (status == 'true') {
      return (true)
    } else {
      return (false);
    }
  });
  const resetContainerStyle = useCallback(() => setDefaultStyle(true), [])
  const ref = useResetContainerStyle<HTMLDivElement>(isDefaultStyle, resetContainerStyle);
  let index = 0;
  const handleNextTaskIndex = (() => {
    if (navigationList) {
      JSON.parse(navigationList).forEach(function (item: any, i: any) {
        if (Object.values(item).includes(currentTask)) {
          index = i;
          // setAnswerType(item.answerType);
        }
      })
      return (index + 1);
    }
  });

  const handleAnswerType = (() => {
    if (navigationList) {
      JSON.parse(navigationList).forEach(function (item: any, i: any) {
        if (Object.values(item).includes(currentTask)) {
          setAnswerType(item.answerType);
        }
      })
    }
  });

  useEffect(() => {
    handleAnswerType();
  }, [currentTask])

  const handleCheckAnswer = (inputToken: string, currentTask: string, answerType: string) => {
    const challengeAnswer = {
      'token': inputToken,
      'task': currentTask,
      'answerType': answerType
    }
    setIsChecking(true);
    checkAnswer(id, challengeAnswer)
      .then((result: any) => {
        const checkAnswerResult = result.data.message;
        console.log(checkAnswerResult);
        if (checkAnswerResult == 'correct') {
          setCorrect(true);
          setIsChecking(false);
          setInputToken('');
          localStorage.setItem(currentTask + ' Complete', 'true');
        } else if (checkAnswerResult == 'prewarming') {
          setDefaultStyle(true);
          setIsChecking(false);
          setInputToken('');
          alert.show('E072', { type: 'info' });
        } else {
          setDefaultStyle(false);
          setCorrect(false);
          setIsChecking(false);
          setInputToken('');
        }
      })
      .catch((err: any) => {
        alert.show('E073', { type: 'error' });
        setDefaultStyle(false);
        setIsChecking(false);
        setInputToken('');
        console.log(err);
      });
  }
  const handleInputToken = (e: ChangeEvent<HTMLInputElement>) => {
    setInputToken(e.target.value);
  }

  if (isCorrect) {
    return <GoNextTask handleEndChallenge={handleEndChallenge} nextTaskIndex={handleNextTaskIndex()} setNavigationFocus={setNavigationFocus} setNavigationClickToRender={setNavigationClickToRender} isFinalTask={isFinalTask} ></GoNextTask>
  } else {
    return (
      <S.Frame>
        <S.Container isDefaultStyle={isDefaultStyle} ref={ref}>
          <S.Img />
          <S.Message>
            <MessageSwitcher
              answerType={answerType}
            />
            {answerType == 'Env' && !isDefaultStyle && <S.TokenWrongMessage answerType={answerType}><FormattedMessage id="E051" /></S.TokenWrongMessage>}
            {answerType == 'Token' && <S.TokenInputField>
              <S.Input value={inputToken} placeholder={intl.formatMessage({ id: 'E046' })} onChange={handleInputToken} isDefaultStyle={isDefaultStyle} onFocus={() => setDefaultStyle(true)} />
              {!isDefaultStyle && <S.TokenWrongMessage answerType={answerType}><FormattedMessage id="E050" /></S.TokenWrongMessage>}
            </S.TokenInputField>}
          </S.Message>
          <S.ButtonFrame>
            <S.Button
              answerType={answerType}
              isDefaultStyle={isDefaultStyle}
              isChecking={isChecking}
              onClick={() => handleCheckAnswer(inputToken, currentTask, answerType)}
            >
              <S.ButtonText
                answerType={answerType}
              >
                <ButtonSwitcher isChecking={isChecking} />
              </S.ButtonText>
            </S.Button>
          </S.ButtonFrame>
        </S.Container>
      </S.Frame>
    )
  }
}

export default CheckAnswer;
